<template>
  <div class="statistics-bar clearfix">
    <div class="status">显示：共有<span class="num">{{totalNum}}</span>条计划</div>
  </div>
</template>

<script>
export default {
  name: 'StatisticsBar',
  props: {
    totalNum: Number
  }
}
</script>

<style lang="scss" scoped>
.statistics-bar {
  @include display-flex;
  font-weight: 500;
  font-size: 1.8rem;
  color: #fff;
  @include respond-to(desktop) {
    display: block;
  }
  .status {
    flex: 1;
    @include respond-to(desktop) {
      float: left;
    }
    .num {
      padding: 0 5px;
      font-weight: bold;
      color: nth($pink, 1);
    }
  }
  .tails {
    padding-left: 10px;
    @include respond-to(desktop) {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/StatisticsBar.vue